import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { utils as coreUtils } from '@industriousapps/excelkits-core';
import { Loader } from '@/components/loaders/Modal';
import envConfig from '@/config/environment';
import { load, getActiveWorksheetIndex } from '@/services/univerjs'; // import environment from '@/config/environment';

import * as univerService from '@/services/univerjs';
import { useToast } from '@/hooks/useToast';
import useUniverEvents from './useUniverEvents';
import useUniverObservers from './useUniverObservers';
import { selectionToRange } from '@/services/univerjs/utils';
import logger from '@/utils/logger';
import styles from './styles.module.scss'; // TODO: lazy load these

import '@univerjs/design/lib/index.css';
import '@univerjs/ui/lib/index.css';
import '@univerjs/docs-ui/lib/index.css';
import '@univerjs/sheets-ui/lib/index.css';
import '@univerjs/sheets-formula/lib/index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PREFIX = 'components: Spreadsheet: UniverSheet:'; // const IS_PRODUCTION = environment.isProduction;

export const UniverSheet = _ref => {
  let {
    data,
    className = '',
    editable = true,
    targetSelection = '',
    syncedAt = 0,
    onChange = () => null,
    onSelect = () => null,
    onSheetSelect = () => null,
    onScroll = () => null,
    onLoad = () => null,
    onWarn = () => null,
    onError = () => null
  } = _ref;
  const {
    addToast: sendNotification
  } = useToast();
  const isInitiated = useRef(false);
  const containerRef = useRef(null);
  const lastSyncedAt = useRef(syncedAt);
  const {
    0: univerAPI,
    1: setUniverAPI
  } = useState(null);
  const {
    0: isLoading,
    1: setIsLoading
  } = useState(false);
  const sheetSelections = useRef([]);
  const sheetScrollOffsets = useRef([]); // Emit raw workbook to parent on change

  const handleOnChange = useCallback(() => {
    if (!univerAPI) return;
    const workbook = univerService.univerFacadeToWorkbook({
      univerAPI: univerAPI,
      isCompiled: false
    });
    const workbookMeta = univerService.univerFacadeToWorkbookMeta(univerAPI);
    onChange(workbook, workbookMeta);
  }, [univerAPI, onChange]); // Bind callbacks to Univer events

  const {
    isSelecting,
    setIsSelecting
  } = useUniverEvents(univerAPI, {
    isEditing: editable,
    sheetScrollOffsets: sheetScrollOffsets.current,
    sheetSelections: sheetSelections.current,
    onChange: handleOnChange,
    onSelect,
    onSheetSelect,
    onScroll,
    onWarn,
    onError
  }); // Update Univer when parameters change

  useUniverObservers(univerAPI, {
    isEditing: editable,
    targetSelection,
    onClipboardError: () => {
      sendNotification({
        description: 'Clipboard Access Required. Please enable clipboard access to use this feature.',
        type: 'error'
      });
    }
  }); // Initiate Univer Instances with
  // current workbook data

  useEffect(() => {
    if (!containerRef.current || isInitiated.current) return;
    setIsLoading(true);
    init(data, containerRef.current, editable).then(uApi => {
      setUniverAPI(uApi);
      isInitiated.current = true;
    }).catch(err => {
      // TODO: improve init/render error
      onError(err);
    }).finally(() => {
      setIsLoading(false);
      setTimeout(onLoad, 500);
    });
  }, [data, editable, onLoad, onError]); // Update Univer Sheet with latest data
  // when synced from remote source

  useEffect(() => {
    if (!univerAPI || !isInitiated.current || lastSyncedAt.current === syncedAt || !syncedAt // Sanity check, no negative timestamps
    ) {
      return;
    }

    lastSyncedAt.current = syncedAt;

    if (envConfig.isDevelopment) {
      logger.info(`${PREFIX} initating Univer Workbook Sync from sync at: ${syncedAt}`);
    }

    syncUniverWorkbook({
      data,
      univerAPI,
      sheetSelections: sheetSelections.current,
      sheetScrollOffsets: sheetScrollOffsets.current
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [univerAPI, lastSyncedAt.current, syncedAt, data]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      /*
      // @ts-ignore */
      ref: containerRef,
      className: clsx(styles.container, 'univer-theme', isSelecting ? 'selecting' : '', editable ? '' : styles['container--uneditable'], className || ''),
      onMouseDown: () => setIsSelecting(true),
      onMouseUp: () => setIsSelecting(false)
    }), isLoading ? /*#__PURE__*/_jsx(Loader, {
      className: styles.loader,
      title: ""
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};
export default UniverSheet; // Download all Univer Sheet deps and
// generate the Sheet instance

async function init(data, containerEl, isEditing) {
  let deps;

  try {
    deps = await load({
      includeUiDeps: true
    });
  } catch (err) {
    throw Error(`${PREFIX} init: failed to load dependencies: ${err}`);
  }

  const {
    Univer,
    LogLevel,
    LocaleType,
    theme,
    locales,
    UniverDocsPlugin,
    UniverFormulaEnginePlugin,
    UniverRenderEnginePlugin,
    UniverSheetsPlugin,
    UniverSheetsFormulaPlugin,
    UniverSheetsUIPlugin,
    UniverDocsUIPlugin,
    UniverSheetsNumfmtPlugin,
    UniverUIPlugin,
    // CustomCommandsPlugin,
    FUniver,
    functionDescriptions,
    functionUser
  } = deps;

  try {
    // Instantiate univer instance
    // @ts-ignore
    const univer = new Univer({
      locales,
      theme,
      // @ts-ignore
      // logLevel: IS_PRODUCTION ? LogLevel.ERROR : LogLevel.VERBOSE,
      logLevel: LogLevel.ERROR,
      // @ts-ignore
      locale: LocaleType.EN_US
    }); // Core plugins

    univer.registerPlugin(UniverDocsPlugin, {
      hasScroll: false
    });
    univer.registerPlugin(UniverDocsUIPlugin);
    univer.registerPlugin(UniverRenderEnginePlugin);
    univer.registerPlugin(UniverUIPlugin, {
      container: containerEl,
      header: isEditing,
      footer: true
    });
    univer.registerPlugin(UniverSheetsPlugin);
    univer.registerPlugin(UniverSheetsUIPlugin, {
      menu: {
        // TODO: not working, check on later versions
        //       of univer that this is getting disabled
        //       properly, currently hackily-hiding this
        //       control with CSS
        'sheet.command.add-worksheet-merge': {
          hidden: true
        },
        'sheet.command.add-worksheet-merge-all': {
          hidden: true
        },
        'sheet.command.add-worksheet-merge-vertical': {
          hidden: true
        },
        'sheet.command.add-worksheet-merge-horizontal': {
          hidden: true
        }
      }
    }); // univer.registerPlugin(CustomCommandsPlugin);
    // Additional feature plugins

    univer.registerPlugin(UniverSheetsNumfmtPlugin, {// TODO: wait until default currency ships #566
      // menu: {
      //   'sheet.command.numfmt.set.currency': {
      //     icon: 'Usd',
      //   },
      // },
    }); // univer.registerPlugin(CustomCommandsPlugin);

    univer.registerPlugin(UniverFormulaEnginePlugin, {
      description: functionDescriptions,
      function: functionUser
    });
    univer.registerPlugin(UniverSheetsFormulaPlugin); // Generate univer sheet
    // @ts-ignore

    univer.createUniverSheet(_objectSpread({}, data));
    return FUniver.newAPI(univer);
  } catch (err) {
    throw Error(`${PREFIX} init: failed to create Univer Sheet: ${err}`);
  }
}

function syncUniverWorkbook(_ref2) {
  let {
    univerAPI,
    data,
    sheetSelections = [],
    sheetScrollOffsets = []
  } = _ref2;
  const activeWorkbook = univerAPI.getActiveWorkbook();
  if (!activeWorkbook) return;
  const activeWorksheetIndex = getActiveWorksheetIndex(activeWorkbook); // Apply scroll offsets & selections from store to data
  // NOTE: not currently working

  Object.entries(data.sheets).forEach(_ref3 => {
    let [sheetId, sheetData] = _ref3;
    const offsets = sheetScrollOffsets.find(_ref4 => {
      let {
        id
      } = _ref4;
      return id === sheetId;
    });
    const sheetSelection = sheetSelections.find(_ref5 => {
      let {
        id
      } = _ref5;
      return id === sheetId;
    });

    if (offsets) {
      sheetData.scrollTop = Math.abs(offsets.x);
      sheetData.scrollLeft = Math.abs(offsets.y);
    }

    if (sheetSelection) {
      // @ts-ignore
      sheetData.selections = [sheetSelection.selection];
    }
  });
  const univerWorkbookId = activeWorkbook.getId();
  univerAPI.disposeUnit(univerWorkbookId);
  univerAPI.createUniverSheet(_objectSpread(_objectSpread({}, data), {}, {
    id: univerWorkbookId
  }));
  const newActiveWorkbook = univerAPI.getActiveWorkbook();
  if (!newActiveWorkbook) return; // Relocate back to user's originally focused sheet

  if (activeWorksheetIndex >= 0) {
    const newActiveSheet = newActiveWorkbook.getSheets()[activeWorksheetIndex] || null;
    newActiveSheet && (newActiveWorkbook === null || newActiveWorkbook === void 0 ? void 0 : newActiveWorkbook.setActiveSheet(newActiveSheet));
    const newSheetId = (newActiveSheet === null || newActiveSheet === void 0 ? void 0 : newActiveSheet.getSheetId()) || '';
    const activeSheetSelections = sheetSelections.find(_ref6 => {
      let {
        id
      } = _ref6;
      return id === newSheetId;
    }); // Convert active sheet to matrix for range calculation

    const sheetData = univerService.worksheetToSheetData(newActiveSheet);
    const sheetDimensions = coreUtils.getMatrixDimensions(sheetData);
    const rangeData = activeSheetSelections && selectionToRange(activeSheetSelections.selection, sheetDimensions) || null; // NOTE: disable when sheet data accepts selections

    rangeData && univerAPI.executeCommand('sheet.operation.set-selections', {
      selections: [{
        range: rangeData
      }],
      unitId: newActiveWorkbook.getId(),
      subUnitId: newSheetId,
      type: 2
    });
  } // Scroll to active last scroll position in each sheet
  // NOTE: setting scroll in worksheet data isn't working


  sheetScrollOffsets.forEach(scrollOffset => {
    const {
      scrollTop,
      scrollLeft
    } = data.sheets[scrollOffset.id] || {};

    if (typeof scrollTop === 'number' && typeof scrollLeft === 'number' && (scrollTop || scrollLeft)) {
      setTimeout(() => {
        univerAPI.executeCommand('sheet.operation.set-scroll', {
          unitId: newActiveWorkbook.getId(),
          sheetId: scrollOffset.id,
          offsetX: scrollTop,
          offsetY: scrollLeft,
          sheetViewStartColumn: 0,
          sheetViewStartRow: 0
        });
      });
    }
  }); // Reload the formula of each worksheet
  // so that they do not appear blank

  newActiveWorkbook.getSheets().forEach(worksheet => {
    const maxRows = worksheet.getMaxRows();
    const maxCols = worksheet.getMaxColumns();
    const range = worksheet.getRange(0, 0, maxCols, maxRows);
    const formulas = (range === null || range === void 0 ? void 0 : range.getFormulas()) || [];
    coreUtils.mapMatrix(formulas, (rowIdx, colIdx) => {
      const formula = formulas[rowIdx][colIdx];
      if (!formula) return;
      const formulaRange = worksheet === null || worksheet === void 0 ? void 0 : worksheet.getRange(rowIdx, colIdx);

      if (formulaRange) {
        formulaRange === null || formulaRange === void 0 ? void 0 : formulaRange.setValue(formula);
      }
    });
  });
}